// extracted by mini-css-extract-plugin
export default {"card":"WidgetsCard_card__bINgQ","cardIcon":"WidgetsCard_cardIcon__CUrQU","title":"WidgetsCard_title__8VgqW","description":"WidgetsCard_description__znlOf"};